import { useTranslate } from "ra-core";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { formatDecimal, formatDuration } from "../domain/format";
import type { RepActivityRow } from "../reports/types";

const NUMERIC = ["dials", "contacts", "demos", "talk_time", "dials_per_hour"];

/** Today's per-rep counters, as returned by the activity RPC (ordered server side). */
export const Leaderboard = ({ rows }: { rows: readonly RepActivityRow[] }) => {
  const translate = useTranslate();
  const head = (k: string) => translate(`gavion.dashboard.leaderboard.${k}`);
  return (
    <Table aria-label={head("title")}>
      <TableHeader>
        <TableRow>
          <TableHead>{head("rep")}</TableHead>
          {NUMERIC.map((k) => (
            <TableHead key={k} className="text-right">
              {head(k)}
            </TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.length === 0 ? (
          <TableRow>
            <TableCell
              colSpan={6}
              className="text-center text-muted-foreground"
            >
              {head("empty")}
            </TableCell>
          </TableRow>
        ) : (
          rows.map((r) => (
            <TableRow key={r.sales_id}>
              <TableCell className="font-medium">{r.name}</TableCell>
              <TableCell className="text-right tabular-nums">
                {r.dials}
              </TableCell>
              <TableCell className="text-right tabular-nums">
                {r.contacts}
              </TableCell>
              <TableCell className="text-right tabular-nums">
                {r.demos}
              </TableCell>
              <TableCell className="text-right tabular-nums">
                {formatDuration(r.talk_seconds)}
              </TableCell>
              <TableCell className="text-right tabular-nums">
                {r.dials_per_hour == null
                  ? "—"
                  : formatDecimal(r.dials_per_hour)}
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
};
